module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6b8d20e70e6d82fd3883f029ce336af5.png";